import {initializeAnalytics} from "@/services/init.analytics.service";
// import {initializeMetaTagHandler} from "@/services/init.meta-tags.service";
import {initGlobalPropertiesService} from "@/services/init.global-properties.service";
import {initExternalServices} from "@/services/init.general.packages.service";

export const appInit = (app,router) => {
    initGlobalPropertiesService(app);
    initializeAnalytics(app,router);
    initExternalServices();
    // initializeMetaTagHandler(app,router);
}